export const SET_BUSINESS_IDEA = 'SET_BUSINESS_IDEA';
export const SET_FETCHED_INITIAL_STATE = 'SET_FETCHED_INITIAL_STATE';
export const SET_SCREEN_SIZE = 'SET_SCREEN_SIZE';
export const NOTIFY_INITIAL_STATE_READY = 'NOTIFY_INITIAL_STATE_READY';
export const SET_NAMES_LIST = 'SET_NAMES_LIST';
export const SET_PICKED_SUGGESTION = 'SET_PICKED_SUGGESTION';
export const SEARCH_BUSINESS_NAMES = 'SEARCH_BUSINESS_NAMES';
export const REMOVE_NAME = 'REMOVE_NAME';
export const LIKED_NAME = 'LIKED_NAME';
export const ENSURE_MOCK_LOGO_SVG = 'ENSURE_MOCK_LOGO_SVG';
export const SET_MOCK_LOGO_SVG = 'SET_MOCK_LOGO_SVG';
export const SORT_NAMES = 'SORT_NAMES';
export const SEARCH_BUSINESS_NAMES_AND_INDUSTRY = 'SEARCH_BUSINESS_NAMES_AND_INDUSTRY';
export const SET_SELECTED_NAME = 'SET_SELECTED_NAME';

// ROUTES
export const GO_BACK = 'GO_BACK';
export const GO_TO_BNG_LIST = 'GO_TO_BNG_LIST';
export const GO_TO_TAGS_SELECTOR = 'GO_TO_TAGS_SELECTOR';
export const GO_TO_PURPOSE_PAGE = 'GO_TO_PURPOSE_PAGE';
export const GO_TO_INDUSTRY = 'GO_TO_INDUSTRY';
export const GO_TO_BUSINESS_NAME = 'GO_TO_BUSINESS_NAME';
export const SKIP_AND_GO_TO_TAGS_SELECTOR = 'SKIP_AND_GO_TO_TAGS_SELECTOR';
export const SKIP_AND_GO_TO_PURPOSE_PAGE = 'SKIP_AND_GO_TO_PURPOSE_PAGE';
export const GO_TO_ROUTE = 'GO_TO_ROUTE';
export const NAVIGATE_TO_LOGO_EDITOR = 'NAVIGATE_TO_LOGO_EDITOR';
export const GET_IT_AND_GOTO_BRANDING = 'GET_IT_AND_GOTO_BRANDING';
export const GO_TO_DOMAIN = 'GO_FROM_BRANDING_TO_DOMAIN';
export const NAVIGATE_TO_CREATE_NEW_WEBSITE = 'NAVIGATE_TO_CREATE_NEW_WEBSITE';
export const NAVIGATE_TO_LOGO_ONBOARDING = 'NAVIGATE_TO_LOGO_ONBOARDING';
export const GO_TO_DOMAIN_PAGE_V3 = 'GO_TO_DOMAIN_PAGE_V3';

// BUSINESS_IDEA
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';

// INDUSTRY
export const SET_INDUSTRY = 'SET_INDUSTRY';

// TAGS
export const UPDATE_LOGO_SELECTOR_TAG = 'UPDATE_LOGO_SELECTOR_TAG';

// BNG Purpose
export const ADD_BNG_PURPOSE = 'ADD_BNG_PURPOSE';
export const REMOVE_BNG_PURPOSE = 'REMOVE_BNG_PURPOSE';
export const GO_TO_BNG_PURPOSE = 'GO_TO_BNG_PURPOSE';
export const FIND_DOMAINS = 'FIND_DOMAINS';
export const FIND_DOMAIN = 'FIND_DOMAIN';

export const SET_DOMAIN_NAME = 'SET_DOMAIN_NAME';

export const LOGIN = 'LOGIN';
export const OVERRIDE_EDIT_COMPANY_DETAILS = 'OVERRIDE_EDIT_COMPANY_DETAILS';
